// Skeleton page for the compta screens whose real content ships page by page
// (docs/projet/interface/): the sidebar can navigate today, each destination
// says what it will become instead of rendering a blank.

import "@app/components/shell/shell.css";

interface ComptaPlaceholderPageProps {
  title: string;
  // One sentence: the question this screen will answer for the accountant.
  question: string;
  // Which spec file describes it (docs/projet/interface/<spec>).
  spec: string;
}

export function ComptaPlaceholderPage({
  title,
  question,
  spec,
}: ComptaPlaceholderPageProps) {
  return (
    <div
      className="compta-rise"
      style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--c-bg)",
      }}
    >
      <div style={{ textAlign: "center", maxWidth: 460, padding: 24 }}>
        <svg
          width="150"
          height="54"
          viewBox="0 0 150 54"
          fill="none"
          aria-hidden
        >
          <g fill="var(--c-ink)">
            <circle cx="75" cy="10" r="3" />
            <circle cx="61" cy="24" r="3" />
            <circle cx="75" cy="24" r="3" />
            <circle cx="89" cy="24" r="3" />
            <circle cx="47" cy="38" r="3" />
            <circle cx="61" cy="38" r="3" />
            <circle cx="75" cy="38" r="3" />
            <circle cx="89" cy="38" r="3" />
            <circle cx="103" cy="38" r="3" />
          </g>
          <g fill="var(--c-border)">
            <circle cx="19" cy="38" r="3" />
            <circle cx="33" cy="38" r="3" />
            <circle cx="117" cy="38" r="3" />
            <circle cx="131" cy="38" r="3" />
          </g>
        </svg>
        <div
          style={{
            fontSize: 22,
            fontWeight: 600,
            marginTop: 18,
            color: "var(--c-ink)",
          }}
        >
          {title}
        </div>
        <div
          style={{
            fontSize: 13,
            color: "var(--c-ink-2)",
            marginTop: 8,
            lineHeight: 1.6,
          }}
        >
          {question}
        </div>
        <div className="compta-cap" style={{ marginTop: 16 }}>
          En construction · spec : docs/projet/interface/{spec}
        </div>
      </div>
    </div>
  );
}
